import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 nlp_transform"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={11} lg={9} className="m-auto text-center">
            <h3 className="h3_head">
              Transform Your Business <span>with NLP Excellence</span>
            </h3>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>Data Collection & Analysis</h5>
                <p>
                  Digitize all data work in one click. Seamless data collection
                  and analysis for actionable insights.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5>Simplified Decision Making</h5>
                <p>
                  Leverage customer insights to adjust your offerings and make
                  informed business decisions quickly.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>Customer Analytics</h5>
                <p>
                  Understand your customers better with advanced analytics,
                  enhancing your ability to meet their needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5>Cost Reduction</h5>
                <p>
                  Reduce operational costs with reliable data automation
                  solutions, improving overall efficiency.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                05
              </div>
              <div className="rapid_content">
                <h5>Improved Content Personalization</h5>
                <p>
                  Deliver personalized content based on customer behavior,
                  increasing engagement and conversion rates.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                06
              </div>
              <div className="rapid_content">
                <h5>Multilingual Capabilities</h5>
                <p>
                  Expand global reach with multilingual support, catering to
                  diverse customer bases effectively.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
